const NotificationMessageType = {
  CRUD: 1,
  COMMAND: 2,
};
// eslint-disable-next-line import/prefer-default-export
export { NotificationMessageType };
